// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

// Internal Dependencies
import Colours from '../../styles/colours';

const FontWeightMap = {
  regular:  300,
  medium:   400,
  semibold: 500,
  bold:     700,
};

const MText = ({ medium, semibold, bold, className, colour, size, text, style, variant, children, onClick }) => {
  const [fontWeight, setFontWeight] = useState(FontWeightMap.regular);

  useEffect(() => {
    if (bold) {
      setFontWeight(FontWeightMap.bold);
    } else if (semibold) {
      setFontWeight(FontWeightMap.semibold);
    } else if (medium) {
      setFontWeight(FontWeightMap.medium);
    } else {
      setFontWeight(FontWeightMap.regular);
    }
  }, [medium, semibold, bold]);

  return (
    <Typography
      className={className}
      variant={variant}
      color="inherit"
      onClick={onClick}
      style={{
        color:    colour,
        fontSize: size,
        fontWeight,
        ...style,
      }}
    >
      {text}
      {children}
    </Typography>
  );
};

MText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Object), PropTypes.array]),

  bold:     PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  medium:   PropTypes.bool,
  semibold: PropTypes.bool,

  className: PropTypes.string,
  colour:    PropTypes.string,
  size:      PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text:      PropTypes.string,
  style:     PropTypes.shape(Object),
  onClick:   PropTypes.func,
  variant:   PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline']),
};

MText.defaultProps = {
  children: null,

  bold:     false,
  medium:   false,
  semibold: false,

  className: '',
  colour:    Colours.Black,
  size:      12,
  text:      '',
  variant:   'body1',
  onClick:   () => {},
  style:     {},
};

export default MText;
